import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'se-stepper-side-nav-formdata',
    templateUrl: './se-stepper-side-nav-formdata.component.html',
    styleUrls: ['./se-stepper-side-nav-formdata.component.scss'],
    standalone: false
})
export class SeStepperSideNavFormdataComponent {

    @Input() formData : any = {};
    details : any[] = [];
    objectKeys = Object.keys
    constructor () {}

    _isTooltipDisabled (element) {
        return element.offsetWidth >= element.scrollWidth;
    }
}
